/** PROTOTYPE documents view -- THROWAWAY. File list + preview (the approved layout). */
import React, { useState } from 'react';
import { CRC } from './moduleInputsData';
import { ProjectState, SpreadPricing } from './spreadSplitData';
import { ServicesPriceResult } from './spreadPricingApi';
import { buildFileList, DocPreview, FileSpec } from './SpreadDocs';

interface Props { project: ProjectState; pricingById: Record<string, SpreadPricing>; services: ServicesPriceResult | null; }

export const SpreadDocsView: React.FC<Props> = ({ project, pricingById, services }) => {
  const files = buildFileList(project);
  const [active, setActive] = useState('pc');
  const spec = files.find((f) => f.key === active) ?? files[0];
  const groups: { title: string; items: FileSpec[] }[] = [
    { title: 'Project', items: files.filter((f) => f.kind.startsWith('project')) },
    { title: 'Per spread', items: files.filter((f) => f.kind.startsWith('spread')) },
  ];
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '230px 1fr', gap: 20, alignItems: 'start' }}>
      <div style={{ background: '#fff', border: `1px solid ${CRC.border}`, borderRadius: 12, padding: 10, position: 'sticky', top: 16 }}>
        <div style={{ fontSize: 11, color: CRC.heritageGrey, padding: '4px 8px' }}>{files.length} files generated</div>
        {groups.map((g) => g.items.length > 0 && (
          <div key={g.title} style={{ marginBottom: 8 }}>
            <div style={{ fontSize: 10, fontWeight: 700, color: CRC.heritageGrey, textTransform: 'uppercase', letterSpacing: '0.05em', padding: '6px 8px' }}>{g.title} · {g.items.length}</div>
            {g.items.map((f) => {
              const on = f.key === spec.key;
              return (
                <button key={f.key} onClick={() => setActive(f.key)}
                  style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', textAlign: 'left', padding: '8px 10px', borderRadius: 8, marginBottom: 2, cursor: 'pointer', fontFamily: 'inherit', border: 'none', background: on ? CRC.heroRed10 : 'transparent', color: on ? CRC.readableRed : CRC.textGrey, fontSize: 12, fontWeight: on ? 600 : 500 }}>
                  <span>{f.label.replace(' · Customer', '').replace(' · Internal', '')}</span>
                  <span style={{ fontSize: 9, color: f.audience === 'Internal' ? CRC.readableRed : CRC.heritageGrey }}>{f.audience === 'Internal' ? 'INT' : 'CUST'}</span>
                </button>
              );
            })}
          </div>
        ))}
      </div>
      <div style={{ background: CRC.pageBg, padding: 24, borderRadius: 12, minHeight: 420 }}>
        <DocPreview project={project} spec={spec} pricingById={pricingById} services={services} />
      </div>
    </div>
  );
};
